var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"google-maps-image",attrs:{"src":_vm.makeSrc()}})
}
var staticRenderFns = []

export { render, staticRenderFns }